import React, { useState, useEffect } from "react";
import {
  Accordion,
  Grid,
  IconButton,
  Box,
  Drawer,
  Stack,
  Button,
  TextField,
  Tooltip,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IngAutoComplete from "../../basic-information/ingredients/IngAutoComplete";
import { DataGrid } from "@mui/x-data-grid";
import { UseProduct } from "./UseProduct";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useSnackbar } from "notistack";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useBreakpoints from "../../hooks/useBreakpoints";
import CustomPagination from "../../components/CustomPagination";

export default function EditLevel7(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [openDerawerIng, setOpenDerawerIng] = React.useState(false);
  const [selectedIngredients, setSelectedIngredients] = React.useState();
  const { generateIngID, isExsit } = UseProduct();
  const { isSmall } = useBreakpoints();

  const [level7, setLevel7] = React.useState({
    ingredientCount: props.product.ingredientCount,
    ingredients: props.product.ingredients,
  });

  const [ingredient, setIngredient] = React.useState({
    id: 0,
    ingredientID: 0,
    faName: "",
    amount: null,
    dailyNeeded: null,
    orderRow: 0,
  });

  useEffect(() => {
    if (props.product) {
      setLevel7({
        ingredientCount: props.product.ingredientCount,
        ingredients: props.product.ingredients,
      });
    }
  }, [props.product]);

  useEffect(() => {
    if (props.fire) {
      Validation7();
    }
  }, [props.fire]);

  const handleDelete = (id) => {
    setLevel7({
      ...level7,
      ingredients: level7.ingredients.filter((row) => row.id !== id),
    });
  };

  const columnsIngr = [
    {
      field: "EditorderRow",
      headerName: "ویرایش ردیف",
      width: 100,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex" }}>
            <Tooltip title="up">
              <IconButton
                sx={{ p: 0 }}
                onClick={() => RowUp(cellValues.row.orderRow)}
              >
                <ArrowDropUpIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="down">
              <IconButton
                sx={{ p: 0 }}
                onClick={() => RowDown(cellValues.row.orderRow)}
              >
                <ArrowDropDownIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "orderRow",
      sortable: false,
      width: 80,
      headerName: "ردیف",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "enName",
      sortable: false,
      width: 400,
      headerName: "عنصر",
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.enName}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      sortable: false,
      width: 150,
      headerName: "مقدار",
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ direction: "rtl", whiteSpace: "normal" }}
          >
            {cellValues.row.amount}
          </Typography>
        );
      },
    },
    {
      field: "dailyNeeded",
      sortable: false,
      width: 100,
      headerName: "نیاز روزانه",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "عملیات",
      headerName: "عملیات",
      width: 100,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  handleDelete(cellValues.row.id);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setIngredient({
                    id: cellValues.row.id,
                    ingredientID: cellValues.row.ingredientID,
                    faName: cellValues.row.faName,
                    enName: cellValues.row.enName,
                    amount: cellValues.row.amount,
                    dailyNeeded: cellValues.row.dailyNeeded,
                    orderRow: cellValues.row.orderRow,
                  });
                  setOpenDerawerIng(true);
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "add",
      width: 150,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderHeader: () => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="spn">افزودن ترکیب</Typography>
            <IconButton
              onClick={() => {
                setIngredient({
                  id: undefined,
                  ingredientID: undefined,
                  faName: "",
                  amount: null,
                  dailyNeeded: null,
                });
                setOpenDerawerIng(true);
              }}
            >
              <AddCircleIcon color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  useEffect(() => {
    if (level7.ingredients) {
      setIngredient({
        ...ingredient,
        id: undefined,
        amount: null,
        dailyNeeded: null,
        faName: "",
        ingredientID: undefined,
      });
    }
  }, [level7.ingredients]);

  return (
    <Accordion
      expanded={props.expanded === "panel7"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel7")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله هفتم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Drawer
          anchor="bottom"
          open={openDerawerIng}
          onClose={() => {
            setReset(true);
            setOpenDerawerIng(false);
          }}
          sx={{
            "&  .MuiDrawer-paper": {
              height: "50% ",
              width: isSmall ? "90%" : "35%",
              mx: "auto",
              borderRadius: 3,
              borderBottomRightRadius: 0,
              borderBottomLeftRadius: 0,
              display: "flex",
              flexDirection: "column",
              p: 3,
            },
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <Typography variant="span" sx={{ mb: 3 }}>
            درج ترکیب :
          </Typography>
          <IngAutoComplete
            reset={reset}
            setReset={setReset}
            setter={setIngredient}
            lvl7State={ingredient}
            openDerawerIng={openDerawerIng}
            selectedIngredients={selectedIngredients}
          ></IngAutoComplete>
          <TextField
            sx={{ my: 3, width: "35%", direction: "rtl" }}
            id="outlined-basic"
            value={ingredient.amount ? ingredient.amount : ""}
            label=" مقدار  "
            size="small"
            fullWidth
            variant="outlined"
            onChange={(evt) => {
              if (evt.target.value) {
                setIngredient({ ...ingredient, amount: evt.target.value });
              } else {
                setIngredient({
                  ...ingredient,
                  amount: null,
                });
              }
            }}
          />
          <TextField
            sx={{ width: "35%", direction: "rtl" }}
            id="outlined-basic"
            size="small"
            fullWidth
            value={ingredient.dailyNeeded ? ingredient.dailyNeeded : ""}
            label="نیاز روزانه"
            variant="outlined"
            onChange={(evt) => {
              if (evt.target.value) {
                setIngredient({
                  ...ingredient,
                  dailyNeeded: evt.target.value,
                });
              } else {
                setIngredient({
                  ...ingredient,
                  dailyNeeded: null,
                });
              }
            }}
          />
          <Box sx={{ display: "flex", alignSelf: "center", gap: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              sx={{ mx: "auto", my: 4 }}
              onClick={() => {
                if (!ingredient.ingredientID) {
                  enqueueSnackbar(
                    "عنصر مشخص نیست، لطفا از لیست عنصرها انتخاب کنید",
                    {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    }
                  );
                  return;
                }

                var tempIngredients = level7.ingredients.slice();

                if (isExsit(tempIngredients, ingredient.id)) {
                  let myObj = isExsit(tempIngredients, ingredient.id);
                  myObj.id = ingredient.id;
                  myObj.faName = ingredient.faName;
                  myObj.enName = ingredient.enName;
                  myObj.ingredientID = ingredient.ingredientID;
                  myObj.orderRow = ingredient.orderRow;
                  myObj.dailyNeeded = ingredient.dailyNeeded;
                  myObj.amount = ingredient.amount;
                  level7.ingredients.map((m) => {
                    if (m.id == myObj.id) {
                      m = myObj;
                    }
                  });
                  // setOpenDerawerIng(false);
                  return;
                }
                let newIng = generateIngID(level7, ingredient);
                tempIngredients.push(newIng);
                setLevel7({
                  ...level7,
                  ingredients: tempIngredients,
                });
                setIngredient({
                  ...ingredient,
                  ingredientID: undefined,
                  faName: "",
                  enName: "",
                });
                setReset(true);
              }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ mx: "auto", my: 4 }}
              onClick={() => {
                setReset(true);

                setOpenDerawerIng(false);
              }}
            >
              بستن
            </Button>
          </Box>
        </Drawer>
        <Grid item xs={12}>
          <Grid item xs={isSmall ? 12 : 3}>
            <TextField
              id="outlined-basic"
              size="small"
              fullWidth
              value={level7.ingredientCount ? level7.ingredientCount : ""}
              label="  به ازای : "
              variant="outlined"
              onChange={(event) => {
                setLevel7({
                  ...level7,
                  ingredientCount: event.target.value,
                });
              }}
            />
          </Grid>

          <Stack sx={{ height: "400px", my: 2 }}>
            <DataGrid
              className="ltr-grid"
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              hideFooter
              columns={columnsIngr}
              rows={level7.ingredients ? level7.ingredients : []}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "orderRow",
                      sort: "asc",
                    },
                  ],
                },
              }}
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  isLtr: true,
                  nofab: true,
                  noPage: true,
                },
              }}
              sortModel={[
                {
                  field: "orderRow",
                  sort: "asc",
                },
              ]}
            />
          </Stack>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel6");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => Validation7()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function RowDown(id) {
    if (id == level7.ingredients.length) {
      return;
    }
    let ind = level7.ingredients.findIndex((m) => m.orderRow == id);
    let ind2 = level7.ingredients.findIndex((m) => m.orderRow == id + 1);
    if (ind == level7.ingredients.length) {
      return;
    }
    let ingList = level7.ingredients.map((m, i) => {
      if (i == ind2) {
        m.orderRow = id;
      }
      if (i == ind) {
        m.orderRow = id + 1;
      }
      return m;
    });
    setLevel7({ ...level7, ingredients: ingList });
  }

  function RowUp(id) {
    if (id == 1) {
      return;
    }
    let ind = level7.ingredients.findIndex((m) => m.orderRow == id);
    let ind2 = level7.ingredients.findIndex((m) => m.orderRow == id - 1);
    if (ind == level7.ingredients.length) {
      return;
    }
    let ingList = level7.ingredients.map((m, i) => {
      if (i == ind2) {
        m.orderRow = id;
      }
      if (i == ind) {
        m.orderRow = id - 1;
      }
      return m;
    });
    setLevel7({ ...level7, ingredients: ingList });
  }

  function Validation7() {
    if (props.fire == false) {
      enqueueSnackbar("مرحله هفتم با موفقیت تکمیل شد", {
        variant: "success",
        preventDuplicate: true,
        autoHideDuration: 2000,
      });
      props.setExpanded("panel8");
    }
    props.fill(level7);
  }
}
